import axios from 'axios';

const baseURL = process.env.REACT_APP_MIT_API;
const baseURLAssistans= process.env.REACT_APP_ASSISTANTS;

export const InterInstance = axios.create({
  baseURL,
  headers: {
    AccessControlAllowOrigin: '*',
    AccessControlAllowMethods: 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  },
});

export const InterInstanceAssistans = axios.create({
  baseURL:baseURLAssistans,
  headers: {
    AccessControlAllowOrigin: '*',
    AccessControlAllowMethods: 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  },
});
